import { createCrudHooks } from './use-crud-factory'
import type { SiteImage } from '@/types/database.types'

/* ============================================================
   useSiteImages — PRD §8.1 Gallery
   CRUD for site image records.
   ============================================================ */

const {
  useList: useSiteImageList,
  useOne: useSiteImage,
  useCreate: useCreateSiteImage,
  useUpdate: useUpdateSiteImage,
  useDelete: useDeleteSiteImage,
} = createCrudHooks<SiteImage>({
  table: 'site_images',
  queryKey: 'site_images',
  orderBy: 'created_at',
  orderAsc: false,
})

export {
  useSiteImageList,
  useSiteImage,
  useCreateSiteImage,
  useUpdateSiteImage,
  useDeleteSiteImage,
}

export { useSiteImageList as useSiteImages }
